import Vue from "vue";
import axios from "axios";
import Cookies from "js-cookie";
import router from "@/router.js";
import { Message } from "element-ui";
import Comjs from "@/assets/js/common.js";
import { refreshTokenMethod } from "./config";

//定义axios
const HOST_URL = process.env.VUE_APP_BASE_API;
const HOST_URL_export = process.env.VUE_APP_EXPORT_API;
Vue.prototype.$httpUrl = HOST_URL;

export const httpAuthAxios = axios.create({
  baseURL: HOST_URL
});

httpAuthAxios.interceptors.request.use(
  (config) => {
    if (
      Cookies.get("Dealer-User-Token") &&
      Cookies.get("Dealer-User-Token") != ""
    ) {
      config.headers.Authorization = Cookies.get("Dealer-User-Token");
      const uerProfile = JSON.parse(localStorage.getItem("dealer_user_profile"));
      if (uerProfile && uerProfile.isGray) {
        config.headers.Location = 'gray';
      }
    }
    return config;
  },
  (err) => {
    console.log(err);
    Message({
      message: "系统错误，请联系管理员！",
      type: "error",
      duration: 3 * 1000
    });
    return Promise.reject(err);
  }
);

httpAuthAxios.interceptors.response.use((response) => {
  // console.log(response,'response==https')
  if (response.status == 201) {
    if (response.data.status == "-1") {
      Message({
        message: response.data.detail,
        type: "error",
        duration: 3 * 1000
      });
      return Promise.reject(null);
    }
    if (response.data.status == "-100") {
      return refreshTokenMethod(response);
      // Message({
      //   message: response.data.detail || '登录过期',
      //   type: "error",
      //   duration: 3000
      // });
      // setTimeout(() => {
      //   Comjs.removeDealer();
      //   router.push("/login");
      // }, 1500)
      // return response;
    }
  }
  if (!response.data) {
    console.warn('响应数据为空:', response.config?.url || 'unknown');
    return Promise.reject(null);
  }
  return response;
}, error => {
  console.log(error,'error==https')
  return Promise.reject('接口错误');
});

Vue.prototype.$httpAuth = httpAuthAxios;

// 导出
export const exportAuthAxios = axios.create({
  baseURL: HOST_URL_export
});

exportAuthAxios.interceptors.request.use(
  (config) => {
    if (
      Cookies.get("Dealer-User-Token") &&
      Cookies.get("Dealer-User-Token") != ""
    ) {
      config.headers.Authorization = Cookies.get("Dealer-User-Token");
    }
    return config;
  },
  (err) => {
    console.log(err);
    Message({
      message: "系统错误，请联系管理员！",
      type: "error",
      duration: 3 * 1000
    });
    return Promise.reject(err);
  }
);

exportAuthAxios.interceptors.response.use((response) => {
  if (response.status == 201) {
    if (response.data.status == "-1") {
      Message({
        message: response.data.detail,
        type: "error",
        duration: 3 * 1000
      });
      return Promise.reject(null);
    }
    if (response.data.status == "-100") {
      // Comjs.removeDealer();
      // router.push("/login");
      // return response;
      return refreshTokenMethod(error.response);
    }
  }
  if (!response.data) {
    console.warn('响应数据为空:', response.config?.url || 'unknown');
    return Promise.reject(null);
  }
  return response;
});

Vue.prototype.$exportAuth = exportAuthAxios;
